import { render, staticRenderFns } from "./_Collect.vue?vue&type=template&id=ee28678e&scoped=true&"
import script from "./_Collect.vue?vue&type=script&lang=js&"
export * from "./_Collect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee28678e",
  null
  
)

export default component.exports